import { CreateElement } from 'vue'
import { Route, RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import * as TYPES from '@/helpers/enums/view-types'
import { PASSPORT_PAGES_ROUTES as ROUTES } from './utils'
import { lkPassportPermissions as Permissions } from '@/helpers/enums/permission-models'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_PASSPORT_PAGES } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'passport-templates',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "passport-templates.store" */
        './store'
      )
      registerModule(options)
      const { registerModule: handbookRegisterModule } = await import(
        /* webpackChunkName: "form-handbook.store" */
        '@/views/FormsHandbook/store/cache'
      )
      handbookRegisterModule(options)
      next()
    },
    component: {
      name: 'view-passport-pages-layout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: [
            Permissions.read,
          ],
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "passport-templates.list" */
          './PassportTemplatesList.vue'
        ),
      },
      {
        path: ':id(\\d+)',
        name: ROUTES.VIEW,
        meta: {
          permission: [
            Permissions.read,
          ],
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "passport-templates.view" */
          './PassportTemplatesView.vue'
        ),
      },
      {
        path: ':id(\\d+)/edit',
        name: ROUTES.EDIT,
        meta: {
          permission: [
            Permissions.edit,
          ],
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.EDIT }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "passport-templates.view" */
          './PassportTemplatesView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => createRoutes(options)

export default createModule
